module.exports = __webpack_public_path__ + "img/google-stadia-03.2e217318.jpg";